import { atom, useAtom } from 'jotai';

const proSubAccountsDialogAtom = atom<string>('');

export const useProSubAccountsDialog = () => {
  const [idProSubAccountsDialogOpen, setProSubAccountsDialogOpen] =
    useAtom(proSubAccountsDialogAtom);

  return {
    idProSubAccountsDialogOpen,
    setProSubAccountsDialogOpen,
  };
};
